import { Component, Input, OnInit } from '@angular/core';
import { FormArray, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgProgress, NgProgressRef } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { Lang, ReferenceParams, Res } from 'src/app/models';
import { LanguageService, NotificationService, ValidatorsService } from 'src/app/services';
import { ApiTagsService } from 'src/app/services/api-tags.service';
import { TagsActionsValidator } from './tags-actions.validators';

@Component({
  selector: 'app-tags-actions',
  templateUrl: './tags-actions.component.html',
  styleUrls: ['./tags-actions.component.css']
})
export class TagsActionsComponent implements OnInit {

  progressRef: NgProgressRef;
  subscriptions: Subscription = new Subscription();
  tagId: string = null;
  tagName: Lang;
  ffInputLang: any = { name: '', valid: false };
  ffInputLangParams = {
    name: {
      clearField: true,
      required: true
    }
  }
  @Input() set data(value) {

    if (value != null) {

      console.log("VALUE ID: ", value);
      
      this.tagId = value;

    }
  }
  tagColor: any;
  tagTextColor: any;
  graphicalPrimitives: any[] = [];
  sizeDetails: any[] = [];

  form: UntypedFormGroup = this.fb.group({
    id: [null],
    name: [null],
    graphic_primitive_id: [null],
    color: [null],
    font_color: [null],
    tag_size_detail_id: [null],
    visible: [true],
    graphics_visible: [false],
    text_visible: [false]
  });

  constructor(
    public ngProgress: NgProgress,
    public activeModal: NgbActiveModal,
    private fb: UntypedFormBuilder,
    private languageService: LanguageService,
    private notification: NotificationService,
    private apiTagsService: ApiTagsService,
    private validator: TagsActionsValidator,
    private validatorService: ValidatorsService
  ) { }

  ngOnInit(): void {

    this.progressRef = this.ngProgress.ref('progress-bar');
    this.getGraphicalPrimitives();
    this.getSizeDetails();
    
    if(this.tagId){

      this.onEdit(this.tagId);
    }

    // this.subscriptions.add(
    //   this.apiTagsService.listenerTagData().subscribe(val => { console.log("TAG VALUE: ", val);
      
    //     if (val) {

    //       this.onEdit(val);
          
    //     }else{

    //       // НА СЛУЧАЙ ЕСЛИ ИЗ ЛИСТА ПЕРЕЙТИ В РЕДАКТИРОВАНИЕ, ВЕРНУТСЯ В ЛИСТ БЕЗ ПРИМЕНЕНИЯ ИЗМЕНЕНИЙ(ПОСРЕДСТВОМ ПЕРЕКЛЮЧЕНИЕ ТАБОВ)
    //       // И СНОВА НАЖАТЬ НА "СОЗДАТЬ ШАБЛОН"
    //       // Чистка arrayForm с данными элементов маппинга
    //        this.form.reset();
    //        this.form.get('visible').setValue(true);
    //        this.tagColor = null;
    //        this.tagTextColor = null;
    //        this.tagName = {ru: '', en: '', kk: ''};
    //     }

    //   })
    // );
  }

  /**
  * 
  * @param fieldName string
  * @param value Lang
  */
  eventFnFF(fieldName: string, value: any): void {

    this.ffInputLang = value;

    this.form.controls[fieldName].setValue(value.name);
  }

  /**
   * 
   */
  getGraphicalPrimitives(): void {

    let params: ReferenceParams = {
      ref_name: 'tags_graphical_primitives',
      filter: {
      }
    }

    this.subscriptions.add(
      this.apiTagsService.getReferences(params, params.ref_name).subscribe((response: any) => {

        if (response != null) {

          this.graphicalPrimitives = response.result;
        }
      })
    );

  }

  /**
   * 
   */
  getSizeDetails(): void {

    let params: ReferenceParams = {
      ref_name: 'tags_sizes_details',
      filter: {
      }
    }

    this.subscriptions.add(
      this.apiTagsService.getReferences(params, params.ref_name).subscribe((response: any) => {

        if (response != null) {

          this.sizeDetails = response.result;
        }
      })
    );

  }

  /**
   * 
   * @param id 
   */
  onEdit(id: string) {

    this.progressRef.start();

    this.subscriptions.add(
      this.apiTagsService.edit(id).subscribe((response: Res) => {
        console.log('[RESPONSE] tagsEdit: ', response);

        if (response != null) {

          this.setTagsData(response.result);

        }

        this.progressRef.complete();
      },
        error => {
          this.progressRef.complete();
        })
    );

  }

  /**
   * 
   * @param data 
   */
  setTagsData(data: any) {

    if (data) {

      this.tagId = data.id;
      this.tagName = data.name;
      this.tagColor = data.color;
      this.tagTextColor = data.font_color;


      this.form.patchValue({
        graphic_primitive_id: data.graphic_primitive_id,
        id: data.id,
        tag_size_detail_id: data.tag_size_detail_id,
        text_visible: data.text_visible,
        graphics_visible: data.graphics_visible,
        visible: data.visible
      });

    }
  }


  /**
   * 
   */
  onCreate() {

    this.progressRef.start();

    let form = { ...this.form.value }
    form.color = this.tagColor;
    form.font_color = this.tagTextColor;

    this.subscriptions.add(
      this.apiTagsService.create(form).subscribe((response: Res) => {
        console.log('[RESPONSE] tagsCreate: ', response);

        if (response != null) {

          this.notification.show('success', 'Метка успешно создана!');
          this.activeModal.close(true);
          // this.apiTagsService.setTagListsData(true);
          // this.apiTagsService.switchTab('list');

          //  // Чистка формы
          //  this.tagName = {ru: '', en: '', kk: ''};
          //  this.form.reset();
          //  this.tagColor = null;
          //  this.tagTextColor = null;
          //  this.form.get('visible').setValue(true);
        }

        this.progressRef.complete();
      },
        error => {
          this.progressRef.complete();
        })
    );

  }

  /**
   * 
   */
  onUpdate() {

    this.progressRef.start();

    let form = { ...this.form.value }
    form.color = this.tagColor;
    form.font_color = this.tagTextColor;

    this.subscriptions.add(
      this.apiTagsService.update(form).subscribe((response: Res) => {
        console.log('[RESPONSE] tagsUpdate: ', response);

        if (response != null) {

          this.notification.show('success', 'Метка успешно изменена!');
          this.activeModal.close(true);
          // this.apiTagsService.setTagListsData(true);
          // this.apiTagsService.switchTab('list');
        }

        this.progressRef.complete();
      },
        error => {
          this.progressRef.complete();
        })
    );

  }

  /**
   * 
   * @param field 
   * @param type 
   */
  validation(field: string, type: string): boolean {

    return this.validatorService.validation(this.form.get(field), type);
  }

}
